import styled from "styled-components";

export const Section = styled.section`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 370px;

    margin-top: 243px;

    @media (max-width: 768px) {
        margin-top: 0;
        place-self: center;
    }
    
`;


export const SuccessContainer = styled.div`
    color: #0ECB00;
    margin-top: 8px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 30px;

    display: flex;
    justify-content: center;
    place-items: center;
    flex-direction: row;

    p {
        color: #4D565C;
        font-size: 1.125rem;
        font-weight: 400;
        margin-bottom: 0;
        margin-left: 13px;
    }

    @media (max-width: 768px) {
        flex-direction: column;
        height: 150px;
        width: 210px;
        border: none;
        margin-top: 0;
        margin-bottom: 40px;
        text-align: center;
        p {
            font-size: 1.125rem;
        }
        svg {
            font-size: 46px;
        }
    }
    
    
`;


export const ButtonContainer = styled.div`
    max-width: 389.91px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;

    a {
        text-decoration: none;
    }
    
    button {
        width: 100%;
    }

    @media (max-width: 768px) {
        margin-top: 0;
    }

`;


export const Header = styled.header`
    display: flex;
    flex-direction: column;

    @media (max-width: 768px) {
        position: absolute;
        top: 0;
        left: 0;
        margin: 81px 22.21px 15px 25px;
        color: white;

        span {
            color: white;
            font-size: 0.75rem;
            display: flex;
            align-items: center;
        }

        h1 {
            color: white;
            font-size: 1.125rem;
            line-height: normal;
        }

        h2 {
            color: #C9DFFF;
            font-size: 0.8125rem;
            line-height: normal;
        }
    }
`;